import { IconArrowLeft, IconArrowRight } from '@lessonup/ui-components';
import React from 'react';
import { PlayerBarBottomSubGroup } from '../PlayerBarBottomPrimitives';
import { PlayerBarBottomButton } from './PlayerBarBottomButton';

export interface PlayerBarBottomNavigationProps {
  onNextClick: (e: React.MouseEvent) => void | Promise<void>;
  onPreviousClick: (e: React.MouseEvent) => void;

  labelPrevious?: string;
  labelSlides?: string;
  labelNext?: string;

  index: number;
  total: number;
  hasPrevious: boolean;
  hasNext: boolean;

  slidesActive?: boolean;
  onSlidesClick?: (e: React.MouseEvent) => void;
  onSlidesMouseDown?: (e: React.MouseEvent) => void;
  slidesButtonRef?: React.Ref<HTMLButtonElement>;
}

export const PlayerBarBottomNavigation: React.FC<PlayerBarBottomNavigationProps> = (props) => {
  const {
    onPreviousClick,
    onNextClick,
    labelPrevious = 'Previous',
    labelSlides = 'Slides',
    labelNext = 'Next',
    index,
    total,
    hasPrevious,
    hasNext,
    slidesActive = false,
    onSlidesClick,
    onSlidesMouseDown,
    slidesButtonRef,
  } = props;

  return (
    <PlayerBarBottomSubGroup>
      <PlayerBarBottomButton
        label={labelPrevious}
        onClick={onPreviousClick}
        iconStart={<IconArrowLeft />}
        tipped
        disabled={!hasPrevious}
      />
      <PlayerBarBottomButton
        label={labelSlides}
        active={slidesActive}
        onClick={onSlidesClick}
        onMouseDown={onSlidesMouseDown}
        ref={slidesButtonRef}
        tipped
        disabled={!onSlidesClick}
      >
        {index}
        {' / '}
        {total}
      </PlayerBarBottomButton>
      <PlayerBarBottomButton
        label={labelNext}
        onClick={onNextClick}
        iconStart={<IconArrowRight />}
        disabled={!hasNext}
        tipped
      />
    </PlayerBarBottomSubGroup>
  );
};
